import { render, staticRenderFns } from "./LivingDonorSocialHistory.vue?vue&type=template&id=3977a44e"
import script from "./LivingDonorSocialHistory.vue?vue&type=script&lang=ts"
export * from "./LivingDonorSocialHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports